import React, { Component } from 'react';
// import { } from "@material-ui/core";
import { QueuePlayNextOutlined, ImportantDevicesOutlined, MobileFriendlyOutlined } from '@material-ui/icons';
// import Particles from 'react-particles-js';
import  Footer from '../Footer/footer';
// import color from '@material-ui/core/colors/amber';

class HomeContainer extends Component {
  constructor(props){
    super(props);
    this.state = {};
  }
  // add function for home background change here
  componentDidMount(){
    this.backgroundChange();
  }
  renderMoon(){
    let homeDiv = document.querySelector(".container-home");
    console.log(homeDiv);

    let moon = document.createElement('div');
    moon.style.width= '20px';
    moon.style.height= '20px';
    moon.style.borderRadius = '50%';
    moon.style.backgroundColor= '#ffffff';
    moon.style.border= '1px 2px';
    moon.style.position = 'absolute';
    moon.style.transition = 'all 0.4s ease-in-out ';
    moon.style.marginLeft = '7%';
    moon.style.marginTop = '7%';
    moon.style.zIndex = '5';
    // renered moon successfully;
    // next clouds and light visibility range  towardss the ground;
    // the 2d grond render;

    console.log(moon);
    homeDiv.appendChild(moon);
    return homeDiv;


  }
  backgroundChange = () => {
    // let homeDiv = document.querySelector(".container-home");
    // background color samples to experiment with
    // let backgroundColor = '#000000';
    // console.log(backgroundColor);
    // get home container
    
    // if(homeDiv){
    //   // console.log(homeDiv.style.background);
    //   // use this to watch for changes later
    //   // let currentBackgroundColor = homeDiv.style.background;
    //   let nextBackground = backgroundColor;
    //   // console.log(nextBackground);
    //   setTimeout(()=>{
    //     this.renderMoon();
    //     // console.log(currentBackgroundColor);
    //     homeDiv.style.background = nextBackground;
    //     // console.log(homeDiv.style.background);
    //     // return newBackground;
    //   }, 6000);
    // }
    
  };

    render(){
      return (
        <div className="container-home">
            <div className="home-icons">
            <MobileFriendlyOutlined className="home-fill"></MobileFriendlyOutlined> 
               <QueuePlayNextOutlined className="home-fill"></QueuePlayNextOutlined>
               <ImportantDevicesOutlined className="home-fill"></ImportantDevicesOutlined>
            </div>

              <h4 className="home-title">Automating Processes of the future..</h4>
            <Footer/>
        </div>
        )
    }
};

export default HomeContainer;